import { ToastContainer } from 'react-toastify'
import useAuthStore from '@/stores/authStore'
import Loading from '@/elements/Loading'
import LoggedOut from '@/router/loggedOut'
import LoggedIn from '@/router/loggedIn'
import Anon from '@/router/Anon'
import InvitationCode from './pages/InvitationCode'
import { queryClient, QueryClientProvider } from './utils/reactQuerty'
import { colors } from './utils/theme'
import './App.scss'

function AppWithContexts() {
  const { loading, isLoggedIn, needsInviteCode, hasOrganizations } = useAuthStore()

  if (loading) {
    return (
      <div style={loadingStyle}>
        <Loading />
      </div>
    )
  }

  if (needsInviteCode) return <InvitationCode />

  if (!isLoggedIn) return <LoggedOut />

  if (!hasOrganizations) return <Anon />

  return <LoggedIn />
}

const loadingStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  backgroundColor: colors['gray-light-60']
} as React.CSSProperties

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWithContexts />
      <ToastContainer className='toast-container' />
    </QueryClientProvider>
  )
}

export default App
